/* 事件掛勾：武將的被動、專屬效果在自己的檔案裡登記「在哪個時間點、第幾順位做什麼」，
 * 核心流程（passives.ts）到了那個時間點就依順位呼叫。順位只在同一個時間點內比較，數字小的先做。
 *
 * 時間點（site）一覽，處理函式的 this 都是 World：
 *   step.hero.early(u, dt)        模擬每步、每名活著的武將，在移動與戰鬥之前（臧霸「青徐之主」）
 *   onHit.pre(u, t)              普攻命中、裝備觸發之前（夏侯淵「連珠」）
 *   aura()                        每 0.5 秒刷新光環時（周倉「忠心」、小喬「紅顏」）
 *   recalc(u, sg)                 重算數值之後（sg 是學會的被動標記）
 *   damage.before(c)              造成傷害前；c = { src, own, t, a, o, act, base }，改 c.a 調整傷害，回傳 true 擋下這次傷害
 *   damage.after(c, lost)         造成傷害後；lost 是實際扣掉的生命
 *   preKill(src, t)               即將陣亡；回傳 true 表示撐住不死
 *   cc.block(c)                   受到控制前；c = { src, own, t, cc }，回傳 true 擋下
 *   cc.tenacity(t, cc)            硬控制的時間縮短百分比（各處加總）
 *   cc.after(t, cc)               縮短過的控制套用之後
 *   attack(u, a, next)            普攻出手（中介層：要繼續就呼叫 next()，不呼叫就是攔下）
 *   heal.mul(t, v)                治療量調整，回傳新的量
 *   cast.before(u, i, x, y)       放技能前；回傳 true 表示已經處理（不走一般流程）
 *   cast.pre(u, i, x, y)          放技能前的準備（不攔截）
 *   cast.ok(u, i)                 一般流程成功施放之後、其他效果之前
 *   cast.after(u, i, sk)          施放成功之後
 *   proj(u, o, next)              發射投射物（中介層，next(u, 新的參數)）
 *   onHit(u, t)                   普攻命中之後
 *   visibility.hero(h)            每名武將的特殊視野（每步重算視野之後）
 *   zone(z, dt)                   每個區域每步；回傳 true 表示這個區域已經處理完
 *   step.hero(u, dt)              每步、每名活著的武將（在 tick 之前）
 *   tick(u, dt)                   每步、每名活著的武將的狀態更新
 *   step.after(dt)                每步、所有武將處理完之後
 *   step.end(dt)                  每步最後
 *   kill.after(src, t, was)       有單位陣亡之後（was：陣亡前是不是活著的武將）
 *   revive(u)                     復活前，清掉進行中的特殊狀態
 *   isEnemy.no(u, t)              回傳 true 表示 u 不把 t 當成敵人（每步呼叫很多次，不用中介層）
 *   control.pre(u, dt)            每步操作處理前，可以改寫指令
 *   goToward.pre(u, x, y, dt)     走向某點前；回傳 true 表示已經處理移動
 *   form(u, from, to)             切換形態之後（u.spec 已經換成新形態；v0.5.0） */

const table: Record<string, { order: number; hero: string; fn: Function }[]> = {};
const EMPTY: { order: number; hero: string; fn: Function }[] = [];

export function on(site: string, order: number, hero: string, fn: Function): void {
  const list = table[site] || (table[site] = []);
  list.push({ order, hero, fn });
  list.sort((a, b) => a.order - b.order); // 穩定排序：同順位維持登記順序
}
export function at(site: string) { return table[site] || EMPTY; }
// 中介層：依順位串起來，最後一層是原本的函式。只在載入時組一次（登記都在載入時完成）
export function chain(site: string, base: Function): Function {
  const list = at(site);
  let fn = base;
  for (let i = list.length - 1; i >= 0; i--) {
    const h = list[i].fn, next = fn;
    fn = function (this: unknown, ...a: unknown[]) { const self = this; return h.call(self, ...a, (...b: unknown[]) => next.apply(self, b.length ? b : a)); };
  }
  return fn;
}
export function sites(): Record<string, { order: number; hero: string }[]> {
  const out: Record<string, { order: number; hero: string }[]> = {};
  for (const k in table) out[k] = table[k].map(({ order, hero }) => ({ order, hero }));
  return out;
}
